import { Link, createFileRoute, redirect } from '@tanstack/react-router'
import { ChartColumn, ClipboardList, MonitorPlay, Tablet } from 'lucide-react'

import { MarcaOP } from '@/components/marca'
import { ConviteInstalar } from '@/components/pwa/convite-instalar'
import { abertoComoApp, areaLembrada } from '@/lib/pwa'

export const Route = createFileRoute('/')({
  // Aberto pelo ícone do app: vai direto para a área que este aparelho usa
  // (tablet → posto, TV → painel, celular do diretor → diretoria).
  beforeLoad: ({ search }) => {
    const peloIcone = (search as { origem?: string }).origem === 'app' || abertoComoApp()
    const area = peloIcone ? areaLembrada() : null
    if (area) throw redirect({ to: area, replace: true })
  },
  component: Inicio,
})

const AREAS = [
  {
    to: '/posto',
    titulo: 'Posto de trabalho',
    descricao: 'Tablet do operador: fila, start/stop, pausas.',
    Icone: Tablet,
  },
  {
    to: '/gestao',
    titulo: 'Gestão / PCP',
    descricao: 'Lançar pedidos, sequenciar, acompanhar.',
    Icone: ClipboardList,
  },
  {
    to: '/painel',
    titulo: 'Painel da fábrica',
    descricao: 'TV em loop com todos os postos.',
    Icone: MonitorPlay,
  },
  {
    to: '/diretoria',
    titulo: 'Diretoria',
    descricao: 'Produção do dia no celular.',
    Icone: ChartColumn,
  },
] as const

function Inicio() {
  return (
    <main className="mx-auto flex min-h-full max-w-5xl flex-col justify-center gap-10 px-4 py-12">
      <header className="flex items-center gap-4">
        <MarcaOP className="size-16" />
        <div>
          <h1 className="text-3xl leading-none tracking-tight">
            <span className="font-light tracking-[0.14em] text-[#00AFEF]">PROJETIVE</span>{' '}
            <span className="font-extrabold">OP</span>
          </h1>
          <p className="mt-1.5 text-fg-muted">Gestão de produção em tempo real</p>
        </div>
      </header>
      <ConviteInstalar contexto="inicio" />
      <nav aria-label="Áreas" className="grid gap-4 sm:grid-cols-2">
        {AREAS.map(({ to, titulo, descricao, Icone }) => (
          <Link
            key={to}
            to={to}
            className="flex press items-start gap-4 card p-6 transition-colors hover:border-brand/60"
          >
            <span className="grid size-12 shrink-0 place-items-center rounded-xl bg-brand/10 text-brand">
              <Icone className="size-6" aria-hidden />
            </span>
            <span>
              <span className="block text-lg font-semibold">{titulo}</span>
              <span className="block text-sm text-fg-muted">{descricao}</span>
            </span>
          </Link>
        ))}
      </nav>
    </main>
  )
}
